<template>
    <div class="payment-board">
        <Loader />
        <header class="page-header">
            <div>
                <div class="container">
                    <h2 class="payment-board__title">Доска платежей</h2>
                    <button @click="refreshTable" class="btn btn-primary">Применить настройки</button>
                </div>
                <div class="payment-board__table">
                    <vue-good-table
                        :columns="columns"
                        :rows="tableData"
                        :pagination-options="paginationOptions"
                        :search-options="searchOptions"
                    >
                        <template slot="table-column" slot-scope="props">
                            <div class="payment-board__head-item">
                                {{props.column.label}}
                            </div>
                            <div v-if="props.column.actions" class="payment-board__dropdown" @click="prevent($event)">
                                <VueCtkDateTimePicker v-if="props.column.actions[0] === 'period'" class="datepicker analytics-header-datepicker mr-3"
                                    v-model="options[props.column.field]"
                                    lang="ru"
                                    color="purple"
                                    :range="true"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    output-format="YYYY-MM-DD"
                                    :noHeader="true"
                                    :noShortcuts="true"
                                    :button-color="'#8a689e'"
                                    :minute-interval="60"
                                    :max-date="rangeMaxDate"
                                    :only-date="true"
                                    :button-now-translation="'Сегодня'"
                                    :autoClose="true"
                                    label="Период"
                                />

                                <select v-else v-model="options[props.column.field]">
                                    <option :value="0">По умолчанию</option>
                                    <option
                                        v-for="(item, index) in translateActions(props.column.actions)"
                                        :key="index"
                                        :value="_getActionByNum(item.target)"
                                    >
                                        {{ item.text }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import Loader from './Loader';
import AnalyticsHeader from './AnalyticsHeader';
import { mapMutations } from 'vuex';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import { getActionByNum, getTranslateByAction, detectMerchant, detectBank, detectAcquirer, detectPaymentType, detectPaymentStatus, checkOptionsAndCreateNew } from '../../utils/payment-board';

export default {
    components: {
        VueGoodTable, Loader, AnalyticsHeader, VueCtkDateTimePicker
    },
    data() {
        return {
            columns: [
                { field: 'id', label: 'Id', type: 'number', actions: ['count'] },
                { field: 'merchant_id', label: 'Id мерчанта', type: 'number', formatFn: detectMerchant },
                { field: 'reference_id', label: 'Reference id', type: 'number', actions: ['count'] },
                { field: 'type', label: 'Тип', actions: ['group'], formatFn: detectPaymentType },
                { field: 'amount', label: 'Сумма', type: 'number', actions: ['sum', 'average'] },
                { field: 'user_id', label: 'User id', type: 'number' , actions: ['group', 'count']},
                { field: 'status', label: 'Статус', type: 'number', actions: ['group'], formatFn: detectPaymentStatus },
                { field: 'description', label: 'Описание' },
                { field: 'try', label: 'Try', type: 'number' },
                { field: 'acquirer_id', label: 'Acquirer Id', type: 'number', actions: ['group'], formatFn: detectAcquirer },
                { field: 'masked_pan', label: 'Masked pan' },
                { field: 'bank_id', label: 'Bank id', type: 'number', actions: ['group', 'count'], formatFn: detectBank },
                { field: 'bank_commission', label: 'Комиссия банка', type: 'number', actions: ['sum', 'average'] },
                { field: 'merchant_commission', label: 'Комиссия мерчанта', type: 'number', actions: ['sum', 'average'] },
                { field: 'comment', label: 'Коммент' }, { field: 'created_at', label: 'Created at', actions: ['period'] },
                { field: 'updated_at', label: 'Updated at', actions: ['period'] }, { field: 'finished_at', label: 'Finished at', actions: ['period'] }
            ],
            tableData: [],
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                nextLabel: 'Далее',
                prevLabel: 'Назад',
                pageLabel: 'Страница',
                rowsPerPageLabel: 'Лимит'
            },
            searchOptions: {
                enabled: true,
                placeholder: 'Поиск',
            },
            options: {
                id: 0,
                reference_id: 0,
                type: 0,
                amount: 0,
                user_id: 0,
                status: 0,
                acquirer_id: 0,
                bank_id: 0,
                bank_commission: 0,
                merchant_commission: 0,
                // Vue timepicker cant hold zero values , only null
                created_at: null,
                updated_at: null,
                finished_at: null
            },
            rangeMaxDate: null
        }
    },
    mounted() {
        this.rangeMaxDate = moment().format('YYYY-MM-DD');
        this.fetchData();
    },
    methods: {
        ...mapMutations({
            setLoading: 'setLoading',
            unsetLoading: 'unsetLoading'
        }),
        async fetchData() {
            try {
                this.setLoading(1)
                const res = await axios.get('/admin/analytics/payment-board');
                this.tableData = res.data
            }
            catch(err) {
                console.log(err);
            }
            finally {
               this.unsetLoading()
            }
        },
        async refreshTable() {
            try {
                this.setLoading(1);
                const optionsToPost = checkOptionsAndCreateNew(this.options);
                await axios.post('/', optionsToPost);
            }
            catch(err) {
                console.log(err)
            }
            finally {
                this.unsetLoading()
            }
        },
        pickAction(field, action) {
            const actionNum = getActionByNum(action)

            if(actionNum) {
                this.options[field] = actionNum;
                console.log(this.options)
            }
        },
        prevent(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        translateActions(arr) {
            const translatedArr = arr.map((item) => {
                return { target: item, text: getTranslateByAction(item) }
            })

            return translatedArr;
        },
        _getActionByNum(action) {
            return getActionByNum(action)
        }
    }
}
</script>

